import {DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {AutoComplete} from "../openings/AutoComplete";
import {api} from "../../../../api/API";
import {useState} from "react";
import {Project, projectLabel} from "../../../../api/Projects";
import {useProjectId} from "../ProjectName";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useReloader} from "../hardware/ReloadContext";

export function LinkBaseBuildingProject(props: {
    onDone(): void;
    onCancel(): void;
}) {
    const [value, setValue] = useState<Project>();
    const project = useProjectId();
    const onDoneRef = useSyncedRef(props.onDone);
    const reload = useReloader();

    const link = useAsyncAction(async (input: {
        project: number;
        baseBuildingProject: number | null;
    }) => {
        await api.keying2.setBaseBuilding(input);
        reload.current();
        onDoneRef.current();
    }, []);

    return (
        <Dialog2 open onClose={props.onCancel}>
            <DialogTitle>
                Link Base Building
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Openings from the selected base building project become available in this project's keying shortcodes. The designations and shortcodes of the base building are added to this project, and its keyed openings are linked to the shortcodes with the same name. Existing designations, shortcodes, and links are kept. The base building project is not changed.
                </DialogContentText>

                <div style={{height: 10}} />

                <AutoComplete<Project>
                    fullWidth
                    search={async search => {
                        const rs = await api.projects.list({search: search, offset: 0, stage: "in-progress"});
                        return rs.data.filter(d => d.id !== project && !d.archived);
                    }}
                    value={value}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={projectLabel}
                    onSelect={setValue} />
            </DialogContent>
            <SmoothActionBar
                loading={link.loading}
                error={link.error}
                onCancel={props.onCancel}
                submitDisabled={!value}
                actionName="Link"
                onSubmit={() => {
                    link.callback({
                        project: project,
                        baseBuildingProject: value?.id || null,
                    });
                }}
            />
        </Dialog2>
    )
}
